import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledContent = styled(StyledFlex)`
   text-align: center;
`;

StyledContent.displayName = 'StyledContent';

export const StyledButtons = styled(StyledFlex)`
   width: 100%;
`;

StyledButtons.displayName = 'StyledButtons';
